import {
  getRefreshToken,
  getLegacyToken,
  setTokens,
  clearAllTokens,
  getRefreshPromise,
  setRefreshPromise,
  clearRefreshPromise
} from './tokenManager'
import { GRAPHQL_ENDPOINT } from '../constants'

const REFRESH_TOKEN_QUERY = `
  mutation RefreshToken($input: RefreshTokenInput!) {
    refreshToken(input: $input) {
      accessToken
      refreshToken
      expiresIn
      user { id name email }
    }
  }
`

const MIGRATE_TOKEN_QUERY = `
  mutation MigrateToken($input: MigrateTokenInput!) {
    migrateToken(input: $input) {
      accessToken
      refreshToken
      expiresIn
      user { id name email }
    }
  }
`

const executeGraphQL = async (query, variables) => {
  const response = await fetch(GRAPHQL_ENDPOINT, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ query, variables })
  })
  const result = await response.json()
  if (result.errors) {
    throw new Error(result.errors[0].message)
  }
  return result.data
}

export const refreshAccessToken = async () => {
  const existingPromise = getRefreshPromise()
  if (existingPromise) {
    return existingPromise
  }

  const promise = (async () => {
    try {
      const refreshToken = getRefreshToken()
      if (!refreshToken) {
        throw new Error('No refresh token available')
      }

      const data = await executeGraphQL(REFRESH_TOKEN_QUERY, {
        input: { refreshToken }
      })

      const result = data.refreshToken
      setTokens({
        accessToken: result.accessToken,
        refreshToken: result.refreshToken,
        expiresIn: result.expiresIn
      })
      return true
    } catch (error) {
      clearAllTokens()
      return false
    } finally {
      clearRefreshPromise()
    }
  })()

  setRefreshPromise(promise)
  return promise
}

export const migrateLegacyToken = async () => {
  const existingPromise = getRefreshPromise()
  if (existingPromise) {
    return existingPromise
  }

  const promise = (async () => {
    try {
      const legacyToken = getLegacyToken()
      if (!legacyToken) {
        throw new Error('No legacy token available')
      }

      const data = await executeGraphQL(MIGRATE_TOKEN_QUERY, {
        input: { legacyToken, platform: 'web' }
      })

      const result = data.migrateToken
      setTokens({
        accessToken: result.accessToken,
        refreshToken: result.refreshToken,
        expiresIn: result.expiresIn
      })
      return true
    } catch (error) {
      clearAllTokens()
      return false
    } finally {
      clearRefreshPromise()
    }
  })()

  setRefreshPromise(promise)
  return promise
}
